import { ActionTypes } from 'modules/experiments/takeover/ducks/actionTypes';
import { CampaignInfoAction, CampaignInfoState } from 'modules/experiments/takeover/types';

export const initialCampaignInfoState: CampaignInfoState = {
  id: null,
  name: null,
  campaignState: null,
  isCampaignSTOEnabled: false,
  type: null,
  isCampaignValid: true,
  hasLocales: false,
};

export const campaignInfoReducer = (
  state = initialCampaignInfoState,
  action?: CampaignInfoAction,
) => {
  switch (action?.type) {
    case ActionTypes.MODAL_OPEN: {
      const campaignInfo = action?.payload || state;
      return {
        ...state,
        ...campaignInfo,
      };
    }

    default:
      return state;
  }
};
